let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a6bZf")).then(() => parcelRequire('1QmuW'));